import React from 'react';

const LoadingSpinner = ({ size = 'h-8 w-8', color = 'text-primary-600' }) => (
  <div className="flex justify-center items-center p-4">
    <div
      className={`animate-spin rounded-full ${size} border-t-2 border-b-2 border-current ${color}`}
      role="status"
    >
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

export default LoadingSpinner;